import React from 'react'
import { isNull, isUndefined } from 'lodash'
import WayPoint from 'react-waypoint'
import Spinner from '../../common/Spinner'
import NoResults from '../../common/NoResults'
import CardItemSwap from './CardItemSwap'

export default ({
  items,
  loading,
  canLoadMoreItems,
  choosedItemsById,
  loadMore,
  addItem,
  removeItem,
}) => {
  return (
    <div>
      {/* Loading items spinner */}
      {loading && isNull(items) && <Spinner centered />}

      {!loading &&
        !isNull(items) &&
        items.length === 0 && <NoResults>Nessun oggetto.</NoResults>}

      {!isNull(items) &&
        items.length > 0 && (
          <div>
            {items.map(item => (
              <CardItemSwap
                showImages
                addItem={addItem}
                removeItem={removeItem}
                key={item.id}
                item={item}
                choosed={!isUndefined(choosedItemsById[item.id])}
              />
            ))}
          </div>
        )}

      {/*  Loading more items spinner */}
      {loading && !isNull(items) && items.length > 0 && <Spinner centered />}

      {/* Trigger load more */}
      {!loading &&
        !isNull(items) &&
        items.length > 0 &&
        canLoadMoreItems && <WayPoint onEnter={loadMore} />}
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/common/Swap/ListItemsModal.js